import store from "../store/";
import VueSocketIO from "vue-socket.io";
import SocketIO from "socket.io-client";
import Vue from "vue";

Vue.use(new VueSocketIO({
    debug: false,
    connection: SocketIO(process.env.VUE_APP_SOCKET_URL, {transports: ['websocket']}), //options object is Optional
    vuex: {
        store,
        actionPrefix: "SOCKET_",
        mutationPrefix: "SOCKET_"
    }
}))
